export const endpoints = {
    submitPersonData: '/restapi/course/{courseId}/enrollment/external/v1',
};

export const fieldIds = {
    firstName: 'FirstName',
    lastName: 'LastName',
    userName: 'UserName',
    password: 'Password',
    emailAddress: 'Mail',
    phone: 'Phone',
    address1: 'Address1',
    address2: 'Address2',
    postalCode: 'PostalCode',
    postalAddress: 'PostalAddress',
    cellularPhone: 'CellularPhone',
    customString1: 'CustomString1',
    customString2: 'CustomString2',
    customString3: 'CustomString3',
    customString4: 'CustomString4',
    customString5: 'CustomString5'
};

export const externalCourseEnrollmentErrorType = {
    invalidProfile: 1,
    invalidEmail: 2
};
